(function () {
    class ManageLandingPageWizard {}

    angular
        .module('dashboard')
        .component('manageLandingPageWizard', {
            templateUrl: 'components/landingpages/wizard/managelandingpage.c5ba4670.html',
            controller: [
                '$scope',
                ManageLandingPageWizard]
        });
})();
